import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output, QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { AddCustomerDialogComponent } from '../../../customer/customer/add-customer/add-customer-dialog/add-customer-dialog.component';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { DocumentService } from 'src/app/core/services/document.service';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import { MatTableDataSource } from '@angular/material/table';
import { EnterpriseEntity } from 'src/app/core/class/enterpriseEntity';
import { UserWithDepartmentEntity } from 'src/app/core/class/UserEntity';
import { MatDialog, MatDialogRef, MatExpansionPanel, MatSort } from '@angular/material';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CommonService } from 'src/app/core/services/common.service';
import { Message } from 'src/app/core/class/message';
import { CreateContractService } from 'src/app/core/services/create-contract.service';
import { EnumContractEnterpriseStatus, EnumContractUserRole } from 'src/app/core/constants/contract';
import { ToastrService } from 'ngx-toastr';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';
import { DocumentCustomerEntity } from 'src/app/core/class/document-customer-entity';
import { CustomerService } from 'src/app/core/services/customer.service';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { NzConfigService } from 'ng-zorro-antd/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ProcedureService } from 'src/app/core/services/procedure.service';
import { distinctUntilChanged, skip, startWith } from 'rxjs/operators';
import { UserService } from "../../../../../../../core/services/user.service";
import { ProcedureComponent } from "../../../../../../../shared/components/procedure/procedure.component";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import {
  AddCustomerApproveDialogComponent
} from "../../../../../../../shared/components/add-customer-approve-dialog/add-customer-approve-dialog.component";
import * as uuid from 'uuid';
import { Common } from '../../../../../../../core/constants/common';

@Component({
  selector: 'app-record-party-sign',
  templateUrl: './record-party-sign.component.html',
  styleUrls: ['./record-party-sign.component.scss']
})
export class RecordPartySignComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  @BlockUI() blockUI: NgBlockUI;
  @Input() check :any;
  permissions: any;

  constructor(
    private documentService: DocumentService,
    public commonService: CommonService,
    public message: Message,
    private createContractService: CreateContractService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private customerService: CustomerService,
    public autoEnterpriseService: AutoEnterpriseService,
    public autoUserService: AutoUserService,
    private nzConfigService: NzConfigService,
    private route: ActivatedRoute,
    private procedureService: ProcedureService,
    private userService: UserService,
    private documentTypeService: DocumentTypeService,
    private cdr: ChangeDetectorRef
  ) {
    super(commonService, message);
    this.subscribeIsInvalidSetPartyFlow = new BehaviorSubject<boolean>(false);
    this.subscribeIsInvalidSetPartyFlowWithConfirmBCT = new BehaviorSubject<boolean>(false);
    this.subscribeIsNotAttestedInvalidSetCreatedSideParty = new BehaviorSubject<boolean>(false);
    this.subscribeIsValidNoUserExist = new BehaviorSubject<boolean>(false);
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.flagCopy) {
        this.flagCopy = true;
      }
      if(queryParams.termination){
        this.termination = queryParams.termination;
        this.terminationType = queryParams.terminationType
      }
    })
    this.formGroup = new FormGroup({
      type: new FormControl(null),
      procedure: new FormControl(null)
    });
    this.approverNumber = localStorage.getItem('approverNumber');
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
    this.permissions = localStorage.getItem('permissions') ? JSON.parse(localStorage.getItem('permissions')) : [];
    this.scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  }

  @ViewChild('contentEmptyTable', { static: false }) contentEmptyTable: TemplateRef<any>; // Set no display No_data on Nz-Table
  flagCopy: boolean = false;
  firstEditLoaded = true;
  public termination: boolean = false;
  public terminationType: number;
  isChangeParentDocument = false;
  private subscribeIsInvalidSetPartyFlow: BehaviorSubject<boolean>;
  private subscribeIsInvalidSetPartyFlowWithConfirmBCT: BehaviorSubject<boolean>
  private subscribeIsNotAttestedInvalidSetCreatedSideParty: BehaviorSubject<boolean>
  isInvalidSetPartyFlow = false;
  isInvalidSetCreatedSideParty = false;
  isInvalidSetPartyFlowWithBCT = false;
  private subscribeIsValidNoUserExist: BehaviorSubject<boolean>;

  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  timeOutQueryServer = null;
  nzCheckLoadingParty = false;
  isLoadingDefaultEnterprise = false;
  public onChangeTemplate = new Subject();
  templateDocument: any;
  private customerDialog: MatDialogRef<AddCustomerDialogComponent>;

  isValidEnterpriseForm = false;

  public onChangePanelData = new Subject();
  document: DocumentEntity;
  ENTERPRISE_DATA: EnterpriseEntity[] = [];
  RECORD_PARTY_SIGN: EnterpriseEntity[] = [];
  RECORD_INTERNAL_USER: any[] = [];
  currentStep = 0;
  typeDoc: number = -1;
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  USER_DATA: UserWithDepartmentEntity[] = [];
  // table
  dataSourceEnterprise = new MatTableDataSource();
  dataSourceUser = new MatTableDataSource();
  valueSelect = null;
  @Input() warningContractQuantity: boolean;
  isFormChanging = false;
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @Output() changePosition: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeDataEnterprise: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetSignPosition: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  valueAddPartyOrder = 2;
  inputPartyValue: string;
  isShowStreamSigningApproval = true;
  RECORD_USER_PERFORM_SIGN: UserWithDepartmentEntity[] = [];
  dataPopupAddUserApprove:any = [];
  enterpriseIdParent: EnterpriseEntity[] = [];
  defaultEnterprises: EnterpriseEntity;
  filteredPartyOptions = [];
  isConfirmBCT = false;
  selectedServiceType: any;
  enterpriseIdInDocument = '';
  showTableMembers = true;
  customer: DocumentCustomerEntity;
  isEmailInvalid = false;
  isPhoneInvalid = false;
  isInvalidPartyOrder = false;
  // -- End of Nghiep vu set Party tham gia ky hop dong --
  // -------------------------------------------------------

  // -- Nghiep vu set User trong luong ky noi bo ---
  // -----------------------------------------------
  inputUserValue: string;
  inputUserSignValue: string;
  nzCheckLoadingUser = false;
  nzCheckLoadingUserSign = false;
  filteredUserOptions = [];
  roleUser = EnumContractUserRole;
  valueSelectedUserRole: string = (this.roleUser.APPROVE + '');
  isValidNoUserExist = false;
  isValidExistingSigning = false;
  filteredInternalUsersOptions = []
  inputInternalUsersValue: string
  nzCheckLoadingInternalUsers = false
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;

  subscriptions: Subscription = new Subscription();

  formGroup: FormGroup;
  procedures: any[] = [];
  searchCtrl: FormControl = new FormControl(null);
  loadingSearchType: boolean = false;
  cecaEnable: boolean;
  isUserSign: boolean;
  indexUserSign: number = -1;
  isShowUserSignTable = true;
  templateId: string;
  valueSelectType: number = -1;
  approverNumber: any;
  isCheckApprover = false;
  isNotAttestedUser: boolean = false;
  scopeType: number;

  ngOnInit() {
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
    this.dataSourceEnterprise.sort = this.sort;
    this.dataSourceUser.sort = this.sort;
    this.getDefaultEnterprises();
    // Get infor Enterprise current
    // if (!this.document.id) {
    //   this.getDefaultEnterprises();
    // }
    this.subscribeData();

    let timeOut;
    this.searchCtrl.valueChanges.pipe(
      startWith(1),
      distinctUntilChanged(),
      skip(1)
    ).subscribe(v => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
      timeOut = setTimeout(() => {
        const controls = this.formGroup.controls;
        this.loadingSearchType = true;
        this.procedureService.searchProcedure(
          {
            name: v,
            status: [0, 1],
            type: controls.type.value ? [Number(controls.type.value)] : [1, 2],
            enterpriseId: localStorage.getItem('enterpriseId'),
            page: 0,
            pageSize: 10,
          }
        ).subscribe(response => {
          this.loadingSearchType = false;
          if (!response || !response.data) {
            return;
          }
          this.procedures = response.data.dataRow;
        });
      }, 500);
    });
  }

  subscribeData() {
    this.subscriptions.add(
      this.createContractService.createContractType.asObservable().subscribe(rs => {
        this.valueSelectType = rs;
        // khong subscribe selectedTemplate tai day: subscription doc lap o duoi
        // (selectedTemplate...) da xu dung vai tro nay; subscribe 2 lan cho cung
        // stream lam API service-type bi goi 2 lan moi khi doi mau
        if(this.flagCopy && this.document && this.document.documentTypeEnterpriseId) {
          // console.log(this.document.documentTypeEnterpriseId);
          this.getServiceTypeByDocumentTypeId(this.document.documentTypeEnterpriseId);
        }
      })
    );
    this.subscriptions.add(
      this.subscribeIsInvalidSetPartyFlow.asObservable().subscribe(res => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.toastr.error(this.message.getMessage('validation.error_enterprise_no_set_up'));
        }
      })
    );

    this.subscriptions.add(
      this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.asObservable().subscribe(res => {
        if (res) {
          // if (this.isConfirmBCT) {
          //   this.createContractService.isInvalidInfo.next(true);
          //   this.toastr.error(this.message.getMessage('validation.error_enterprise_no_set_up_confirm_bct'));
          // } else {
          //   this.createContractService.isInvalidInfo.next(false);
          // }
          this.createContractService.isInvalidInfo.next(true);
          if (this.isConfirmBCT) {
            this.toastr.error(this.message.getMessage('validation.error_enterprise_no_creataer'));
          } else {
            this.toastr.error(this.message.getMessage('validation.error_enterprise_no_set_up_inconfirm_bct'));
          }
        }
      })
    );

    this.subscriptions.add(
      this.subscribeIsNotAttestedInvalidSetCreatedSideParty.asObservable().subscribe(res => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.toastr.error(this.message.getMessage('validation.error_enterprise_not_attested_no_setup_created_side'));
        }
        // if (res) {
        //   if (this.isNotAttestedUser) {
        //     this.createContractService.isInvalidInfo.next(false);
        //   } else {
        //     this.createContractService.isInvalidInfo.next(true);
        //     this.toastr.error(this.message.getMessage('validation.error_enterprise_not_attested_no_setup_created_side'));
        //   }
        // }
      })
    );
    this.subscriptions.add(
      this.subscribeIsValidNoUserExist.asObservable().subscribe(res => {
        if (res) {
          this.createContractService.isInvalidInfo.next(true);
          this.toastr.error(this.message.getMessage('validation.error_user_no_set_up'));
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.recordsPartySign.asObservable().subscribe(res => {
        if (res.length) {
          this.RECORD_PARTY_SIGN = res;
          this.showTableMembers = this.checkExistedCreatorParty();
          this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
            return o.order;
          })) + 1;
        } else if (this.createContractService.cacheRecordParty) {
          this.showTableMembers = false;
          this.valueAddPartyOrder = 1;
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.recordsInternalUsers.asObservable().subscribe(res => {
        this.RECORD_INTERNAL_USER = res;
      })
    );

    this.subscriptions.add(
      this.createContractService.recordsUserPerformSign.asObservable().subscribe(res => {
        this.RECORD_USER_PERFORM_SIGN = res;
        if (res) {
          const checkUserSign = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1');
          if (checkUserSign.length > 0) {
            this.isUserSign = true;
            this.indexUserSign = this.RECORD_USER_PERFORM_SIGN.indexOf(checkUserSign[0]);
          } else {
            this.isUserSign = false;
            this.indexUserSign = -1;
          }

          const checkApprover = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '2');
          if (checkApprover.length === Number(this.approverNumber) || checkApprover.length > Number(this.approverNumber)) {
            this.isCheckApprover = true;
          } else {
            this.isCheckApprover = false;
          }

          this.currentStep = this.createContractService.currentStep.getValue();
          if(this.createContractService.currentStep.getValue() == 2) {
            this.sortOrderApproveSign();
          }
        }
      })
    );

    // this.createContractService.currentStep.asObservable().subscribe(res => {
    //   if (res) {
    //     this.currentStep = res;
    //     if (res === 1) {
    //       this.onSubmit();
    //     }
    //   }
    // });
    this.subscriptions.add(
      this.createContractService.isGeneralInfoValid.asObservable().subscribe(rs => {
        if (rs) {
          this.onSubmit();
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.isBack.asObservable().subscribe(rs => {
        if (rs) {
          this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
          this.createContractService.recordsInternalUsers.next(this.RECORD_INTERNAL_USER);
          this.createContractService.recordsUserPerformSign.next(this.RECORD_PARTY_SIGN.length ? this.RECORD_USER_PERFORM_SIGN : []);
          this.createContractService.isBack.next(false);
        }
      })
    )

    this.subscriptions.add(
      this.createContractService.document.asObservable().subscribe(res => {
        if (res) {
          this.document = res;
          if (this.document && this.document.id && this.createContractService.currentStep.getValue() === 0 && !this.createContractService.recordsPartySign.getValue().length && !this.createContractService.recordsUserPerformSign.getValue().length) {
            this.initDataUpdate(this.document);
          } else if (this.termination && this.terminationType == 2 && this.createContractService.currentStep.getValue() === 0 && !this.createContractService.recordsPartySign.getValue().length && !this.createContractService.recordsUserPerformSign.getValue().length){
            this.initDataUpdate(this.document);
          }
        }
      })
    );

    this.subscriptions.add(
      this.createContractService.saveRecordParty.asObservable().subscribe(res => {
        if (res) {
          this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
          this.createContractService.saveRecordParty.next(false);
        }
      })
    )
    this.subscriptions.add(
      this.createContractService.isConfirmBCT.asObservable().subscribe(res => {
        this.isConfirmBCT = res
      })
    );
    this.subscriptions.add(
      this.createContractService.selectedTemplate.asObservable().subscribe(rs => {
        // step 0 co 2 instance (check=1 va check=2); instance check=2 chi hien panel
        // chuyen tiep, khong dung luong ky tu mau -> bo qua de API khong bi goi 2 lan
        if (this.check == 2) {
          return;
        }
        if (rs && !(this.document && this.document.id) && !this.RECORD_USER_PERFORM_SIGN.length) {
          this.templateId = rs.id;
          this.getServiceTypeByDocumentTypeId(rs.id)
            // silent: khong block UI toan trang khi chon mau
            this.documentService.getListEnterpriseUserSignByTemplateIdSilently(rs.id).subscribe(res => {
              if(res){
                this.getListUserWillSignContractByTemplate(res.data);
              }
            })
        }
      })
    );
    this.subscriptions.add(
      this.createContractService.selectedServiceType.asObservable().subscribe((res:any) => {
       if (this.valueSelectType == 1) {
        if (res && res.internalFlowNotEdit === true) {
          if (this.selectedServiceType) {
              this.RECORD_USER_PERFORM_SIGN = [];
              this.createContractService.recordsUserPerformSign.next([]);
          } else {
              if (!(this.document)) {
                this.RECORD_USER_PERFORM_SIGN = [];
                this.createContractService.recordsUserPerformSign.next([]);
              }
          }
        }
        this.selectedServiceType = res;
       } else {
        this.selectedServiceType = res;
       }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    // Set empty when nz-table has NO-DATA
    this.nzConfigService.set('empty', { nzDefaultEmptyContent: this.contentEmptyTable });
    // Change state first edit loaded to false after 3s because there is no way to know
    // which observable finish last.
    setTimeout(_ => this.firstEditLoaded = false, 7000);
  }

  // Xóa chu the trong bảng Enterprise
  onClickDeleteElementRecordEnterprise(dataRow: any) {
    // this.setFormChanging(true);
    if (dataRow !== null && dataRow !== undefined) {
      const index: number = this.ENTERPRISE_DATA.indexOf(dataRow);
      if (index !== -1) {
        this.ENTERPRISE_DATA.splice(index, 1);
      }

      this.ENTERPRISE_DATA = this.ENTERPRISE_DATA.map((item, idx) => {
        return {
          ...item,
          order: idx + 1
        };
      });
      this.dataSourceEnterprise = new MatTableDataSource(this.ENTERPRISE_DATA);
      this.validateFormEnterprise();
      this.checkIsSameEntepriseCurrentLogin();
    }
  }

  // validate form Enterprise.
  private validateFormEnterprise() {
    if (this.ENTERPRISE_DATA.length === 0) {
      this.isValidEnterpriseForm = true;
    } else {
      this.isValidEnterpriseForm = false;
    }
  }

  // Check nó có pải được set luồng Ký/Duyệt hay ko?
  private checkIsSameEntepriseCurrentLogin() {
    if (this.ENTERPRISE_DATA !== null && this.ENTERPRISE_DATA.length !== undefined) {
      if (this.ENTERPRISE_DATA.filter(x => x.enterpriseId === this.defaultEnterprises.enterpriseId).length > 0) {
        this.isShowStreamSigningApproval = true;
        this.enterpriseIdParent = this.ENTERPRISE_DATA.filter(x => x.isCreatedSide === true);
      } else {
        this.isShowStreamSigningApproval = false;
      }
    } else {
      this.isShowStreamSigningApproval = false;
    }
  }

  initDataUpdate(document) {
    // console.log(document);
    this.document = document;
    // if (serviceType) {
    //   this.document.serviceType = serviceType.id;
    // }
    this.getListEnterpriseUserSignBydocumentId();
  }

  getListEnterpriseUserSignBydocumentId() {
    // step 0 co 2 instance (check=1 va check=2); instance check=2 chi hien panel
    // chuyen tiep, khong dung du lieu luong ky -> bo qua de API khong bi goi 2 lan
    if (this.check == 2) {
      return;
    }
    if (this.document && this.document.id) {
      // silent: khong block UI toan trang khi tai luong ky
      this.documentService.getListEnterpriseUserSignBydocumentIdSilently(this.document.id).subscribe(rs => {
        if (rs.data) {
          localStorage.setItem('userSignAllCustomer',JSON.stringify(rs.data.userSignAll));
          this.getListEnterpriseWillSign(rs.data.enterpriseSign);
          this.getListUserWillSignContract(rs.data.userSign);
        }
      }, (error) => console.log(error));
    } else if(this.termination && this.terminationType == 2){
      this.documentService.getListEnterpriseUserSignBydocumentIdSilently(this.document.contractTerminationId).subscribe(rs => {
        if (rs.data) {
          localStorage.setItem('userSignAllCustomer',JSON.stringify(rs.data.userSignAll));
          this.getListEnterpriseWillSign(rs.data.enterpriseSign);
          this.getListUserWillSignContract(rs.data.userSign);
        }
      }, (error) => console.log(error));
    }
  }

  // /**
  //  * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng && Lấy danh sách các bên chủ thể sẽ Ký Hợp đồng
  //  */
  getListEnterpriseUserSignForCopy() {
    if (this.document && this.document.id) {
      // silent: khong block UI toan trang khi copy
      this.documentService.getListEnterpriseUserSignForCopySilently(this.document.id).subscribe(rs => {
        if (rs.data) {
          this.getListEnterpriseWillSign(rs.data.enterpriseSign);
          this.getListUserWillSignContract(rs.data.userSign);
        }
      }, (error) => console.log(error));
    }
  }

  // /**
  //  * Lấy danh sách Người dùng sẽ ký/Duyệt Hợp đồng
  //  */
  getListUserWillSignContract(data) {
    if (data) {
      this.RECORD_USER_PERFORM_SIGN = data.map(item => ({
        ...item,
        order: item.order,
        userId: item.userId,
        enterpriseSignId: item.enterpriseSignId,
        name: item.userName,
        email: item.userEmail,
        role: item.role + '',
        phone: item.userPhone,
        isSignDigitalCertificate: item.isSignDigitalCertificate ? item.isSignDigitalCertificate : false,
        isCreatedSide: true,
        signConfig: item.signConfig ? this.setDataSignConfig(JSON.parse(item.signConfig)) : { resize: false, showImage: item.isSignDigitalCertificate ? true : (item.role + '' == '1' ? true : false) }
      }));
      if (this.flagCopy) {
        if (this.selectedServiceType && this.selectedServiceType.internalFlowNotEdit) {
          this.RECORD_USER_PERFORM_SIGN = [];
        }
      }
      this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
      // thiết lập enterpriseIdInDocument theo hợp đồng draft ban đầu
      if (this.RECORD_USER_PERFORM_SIGN.length > 0) {
        this.enterpriseIdInDocument = this.RECORD_USER_PERFORM_SIGN[0].enterpriseSignId;
        this.showTableMembers = true;
      } else {
        this.showTableMembers = false;
      }
    } else {
      // console.log('ERROR function getListUserWillSignContract');
    }
  }

  getListUserWillSignContractByTemplate(data) {
    if (data && data.length) {
      this.RECORD_USER_PERFORM_SIGN = data.map(item => ({
        order: item.role == 1 ? data.length : item.order,
        userId: item.id,
        enterpriseSignId: item.enterpriseId,
        name: item.name,
        email: item.email,
        role: item.role + '',
        phone: item.phone,
        isCreatedSide: true,
        departmentName: item.departmentName,
        isSignDigitalCertificate: item.isSignDigitalCertificate ? item.isSignDigitalCertificate : false,
        departmentId: item.departmentId,
        signConfig: item.signConfig ? this.setDataSignConfig(JSON.parse(item.signConfig)) : { resize: false, showImage: item.isSignDigitalCertificate ? true : (item.role + '' == '1' ? true : false) },
        userPosition: item.userPosition
      }));
      this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
      // thiết lập enterpriseIdInDocument theo hợp đồng draft ban đầu
      if (this.RECORD_USER_PERFORM_SIGN.length > 0) {
        this.enterpriseIdInDocument = this.RECORD_USER_PERFORM_SIGN[0].enterpriseSignId;
        this.showTableMembers = true;
      } else {
        this.showTableMembers = false;
      }
    } else {
      this.RECORD_USER_PERFORM_SIGN = [];
      this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
      this.isUserSign = false
      // console.log('ERROR function getListUserWillSignContract');
    }
  }
  //khi cập nhật hợp đồng map data
  getListEnterpriseWillSign(data) {
    if (data) {
      this.RECORD_PARTY_SIGN = data.map(item => ({
        enterpriseId: item.enterpriseId,
        order: item.order,
        email: item.enterpriseEmail,
        enterpriseName: '',
        phone: item.enterprisePhone,
        status: item.status,
        isCreatedSide: (item.customerId) ? false : true,        // CHÚ Ý ĐIỀU CHỈNH LẠI
        name: item.enterpriseName,
        certificateNo: (item.enterpriseCertificateNo) ? item.enterpriseCertificateNo : '',
        customerId: item.customerId,
        useDataForTemplate: item.useDataForTemplate,
        customerApproves:[],
        isSignNoLogin: item.isSignNoLogin,
        customerType:item.customerType,
        isSetupSignFlow:item.isSetUpSignFlow ? item.isSetUpSignFlow:false,
        contractEnterpriseId:item.contractEnterpriseId,
        signConfig: item.signConfig ? this.setDataSignConfig(JSON.parse(item.signConfig)) : { resize: false, showImage: item.customerId ? false : true }
      }));
      this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
        return o.order;
      })) + 1;
      const userSignAllCustomer = JSON.parse(localStorage.getItem('userSignAllCustomer')) ;
      if(userSignAllCustomer.length > 0){
        localStorage.removeItem('userSignAllCustomer');
        this.RECORD_PARTY_SIGN.forEach(ele => {
          userSignAllCustomer.forEach(ala => {
            if(!ele.isCreatedSide && ele.contractEnterpriseId == ala.id){
              ala.data.forEach(element =>{
                if(element.role != 1){
                  ele.customerApproves.push(element);
                }
              })
            }
          })
        })
        this.RECORD_PARTY_SIGN.forEach(ele =>{
          ele.customerApproves.forEach(ala =>{
            if(!ala.isCreatedSide && (ala.role == 2 || ala.role == 7)){
              ala.userId = ala.userId || ala.userSignatureId || uuid.v4()
              ala.enterpriseId = ala.enterpriseId || uuid.v4()
              ala.customerId = uuid.v4()
              ala.STT  = ala.order
              ala.name = ala.userName
              ala.phoneNumber = ala.userPhone
              ala.email = ala.userEmail
              ala.taxCode = ala.taxCode
              ala.CTS = ala.isSignDigitalCertificate
              if(typeof ala.signConfig == 'string' ){
                const a = JSON.parse(ala.signConfig);
                ala.image = a.showImage
                ala.resize = a.resize
              }
              else{
                ala.image = ala.signConfig.showImage
                ala.resize = ala.signConfig.resize
              }
              ala.checkMail = false
              ala.checkTrung = false
              ala.checkFocusSTT = false
              ala.checkFocusName = false
              ala.checkFocusMail = false
              ala.checkFocusPhone = false
              ala.checkFocusCertificate = false
              ala.checkPhone = false
              ala.checkCertificate = false
              ala.validateForm = false
            }
          })
        });
      }
      this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
      this.createContractService.cacheRecordParty = JSON.parse(JSON.stringify(this.RECORD_PARTY_SIGN));
      // this.ENTERPRISE_DATA = data.map(item => ({ ...item, phone: item.enterprisePhone, email: item.enterpriseEmail }));

      // //set value expanded when start.
      // for (var i: number = 0; i < this.ENTERPRISE_DATA.length; i++) {
      //   this.expanded[i] = false;
      // }

      // //new table enterprise.
      // this.dataSourceEnterprise = new MatTableDataSource(this.ENTERPRISE_DATA);
    } else {
      console.log('ERROR function getListEnterpriseWillSign');
    }
  }

  // TRY: APPLY NZ-TABLE FOR CREATE DOCUMENT

  // -- Nghiep vu set Party tham gia ky hop dong --
  // ------------------------------------------------

  // /**
  //  * Lấy thông tin doanh nghiệp khi đăng nhập vào
  //  */
  getDefaultEnterprises() {
    // => push element first to array nếu nó không phải đang edit
    this.enterpriseIdInDocument = localStorage.getItem('enterpriseId');
    if (this.createContractService.currentStep.value === 0) {
      // step 0 mount 2 instance component nay (check=1, check=2) -> dung cache chung de chi goi 1 api
      this.isLoadingDefaultEnterprise = true;
      this.createContractService.getDefaultEnterprise(this.enterpriseIdInDocument).subscribe(rs => {
        this.isLoadingDefaultEnterprise = false;
        if (rs && rs.data && !this.RECORD_PARTY_SIGN.length) {
          this.RECORD_PARTY_SIGN = [
            {
              enterpriseId: rs.data.id || '',
              order: 1,
              email: rs.data.email || '',
              enterpriseName: '',
              phone: rs.data.phone || '',
              status: this.enumContractEnterpriseStatus.NO_PROCESS,
              isCreatedSide: true,
              customerId: '',
              name: rs.data.name || '',
              certificateNo: (rs.data.taxCode && rs.data.taxCode.length > 0) ? rs.data.taxCode : rs.data.certificateNo,
              useDataForTemplate: false,
              isSignNoLogin: rs.data.isSignNoLogin,
              signConfig: rs.data.signConfig ? this.setDataSignConfig(JSON.parse(rs.data.signConfig)) : { resize: false, showImage: true }
            }
          ];
          // this.createContractService.recordsPartySign.next(RECORD_PARTY_SIGN);
        }
      }, (error) => {
        this.isLoadingDefaultEnterprise = false;
        console.log(error);
      });
    }

  }

  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              // console.log('record party sign result', result);

              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if (item.isCreatedSide) {
                    if (!this.checkExistedCreatorParty()) {                        // Nếu đã có 1 đơn vị của bên Lập rồi thì ko cho thêm đơn vị khác của bên Lập nữa
                      // Chống lặp bản ghi trong danh sách suggest
                      const existedList = this.filteredPartyOptions.filter((e) => {
                        return e.enterpriseId === item.enterpriseId;
                      });
                      // if (existedList.length === 0) {
                        this.filteredPartyOptions.push(item);
                      // }
                    }
                  } else if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {        // Nếu chưa được chọn thì cũng mới hiển thị cho chọn
                    // Chống lặp bản ghi trong danh sách suggest
                    const existedList = this.filteredPartyOptions.filter((e) => {
                      return e.enterpriseId === item.enterpriseId;
                    });
                    // if (existedList.length === 0) {
                      this.filteredPartyOptions.push(item);
                    // }
                  }
                }
              }
              // this.filteredPartyOptions = result;
            }).finally(() => {
              this.nzCheckLoadingParty = false;
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }

  onChangeInternalUsersSearch($event: any): void {
    this.filteredInternalUsersOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.inputInternalUsersValue.trim().length > 0) {
        this.nzCheckLoadingInternalUsers = true;
        this.autoEnterpriseService.searchUserOrDepartment(this.inputInternalUsersValue.trim())
          .then(result => {
            this.filteredInternalUsersOptions = [];
            if (result) {
              this.filteredInternalUsersOptions = result
            }
          }).finally(() => {
            this.nzCheckLoadingInternalUsers = false;
          });
      } else {
        this.inputInternalUsersValue = '';
      }
    }
  }

  // Function handler set sự thay đổi trên form.
  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  onChangeOrderOfPartySign() {
    this.setFormChanging(true);
    this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map(item => {
      return item.order;
    })) + 1;
  }

  onChangeOrderApproveSign() {
    this.setFormChanging(true);
  }

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '2')];
    let RECORD_USER_SIGN = [...this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1')];

    if(RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE = RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if(index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if(item.order !== RECORD_USER_APPROVE[index -1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
  }
  // Thêm mới khách hàng vào danh sách
  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: model.enterpriseId,
            order: this.valueAddPartyOrder,
            email: model.email,
            enterpriseName: '',
            phone: model.phone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: model.isCreatedSide,
            customerId: model.customerId,
            name: model.name,
            certificateNo: (model.taxCode) ? model.taxCode : model.certificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            customerType : model.customerType,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: false }
          }
        ];
        // console.log(this.RECORD_PARTY_SIGN);

        this.showTableMembers = this.checkExistedCreatorParty();
        this.validateSetupParty(true);
        if (model.isCreatedSide) {                                   // cập nhật enterpriseSignId nếu chủ thể bên lập thay đổi
          this.enterpriseIdInDocument = model.enterpriseId;
          this.updateEnterpriseIdofUserList();
        }

        this.setFormChanging(true);
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
          return o.order;
        })) + 1;
        this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }

  autocompleteInternalUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedInternalUser(model.type === 'USER' ? model.id : model.departmentId)) {
        this.RECORD_INTERNAL_USER = [
          ...this.RECORD_INTERNAL_USER,
          {
            email: model.email,
            name: model.name,
            departmentName: model.departmentName,
            departmentCode: model.departmentCode,
            id: model.type === 'USER' ? model.id : model.departmentId,
            type: model.type,
            representativeId: model.representativeId,
            representativeIsActive: model.representativeIsActive,
            userPosition: model.userPosition
          }
        ];
        // console.log(this.RECORD_PARTY_SIGN);


        this.setFormChanging(true);
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        this.createContractService.recordsInternalUsers.next(this.RECORD_INTERNAL_USER);

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_forward_duplicate'), model.type === 'USER' ? model.name : model.departmentName));
      }
    }
  }

  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
    });

    return (existedList.length > 0);
  }

  checkExistedInternalUser(id: string) {
    const existedList = this.RECORD_INTERNAL_USER.filter((e) => {
      return e.id === id || e.departmentId === id;
    });

    return (existedList.length > 0);
  }

  checkExistedCreatorParty(): boolean {
    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true;
    });

    return existedList.length > 0;
  }



  onClickDeleteElementRecordParty(enterpriseId: any, customerId:any): void {
    if (enterpriseId && enterpriseId.length > 0) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(d => d.enterpriseId !== enterpriseId);
      const positions = this.createContractService.signPositions.getValue();
      const positionDataChange = positions.filter(position => !(position.enterpriseId === enterpriseId));
      this.createContractService.signPositions.next(positionDataChange);
    } else {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.filter(d => d.customerId !== customerId);
      const positions = this.createContractService.signPositions.getValue();
      const positionDataChange = positions.filter(position => !(position.customerId === customerId));
      this.createContractService.signPositions.next(positionDataChange);
    }
    this.changeDataEnterprise.emit(true);
    if (this.RECORD_PARTY_SIGN && this.RECORD_PARTY_SIGN.length > 0) {
      this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
        return o.order;
      })) + 1;
    } else {
      this.valueAddPartyOrder = 1;
    }

    if(enterpriseId === undefined || enterpriseId === null) enterpriseId = '';
    let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(d => d.enterpriseId !== enterpriseId);

    this.showTableMembers = this.checkExistedCreatorParty();
    this.setFormChanging(true);
    this.validateSetupParty(true);
    this.validateErrorSetUser();
    this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
    this.createContractService.recordsUserPerformSign.next(RECORD_USER_PERFORM_SIGN);
  }

  onSelectCustomerForTemplate(id: any, value: boolean): void {
    this.setFormChanging(true);
    if (value) {            // Nếu chọn 1 khách hàng để bind information into template
      if (id != null) {
        // Re-set những khách hàng khác là ko được chọn bind information into template
        this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map((item) => {
          return {
            ...item,
            useDataForTemplate: item.customerId === id
          };
        });
        // this.createContractService.recordsPartySign.next(RECORD_PARTY_SIGN);

        // Bind customer data to template
        this.document.customerId = id;
        this.onChangeTemplate.next(this.templateDocument);
      }
    }
  }

  // /**
  //  * Open dialog add customer
  //  * new version - 09.2020
  //  */
 get isFromSSO(){
  if( localStorage.getItem('isFromSSO') =='true'){
    return true
  }
  return false
 }

  public openAddCustomer() {
    this.customerDialog = this.dialog.open(AddCustomerDialogComponent, {
      width: '70%',
      data: true
    });

    this.customerDialog.componentInstance.createSuccess.asObservable().subscribe(() => {
      this.getCustomerById(this.documentService.getCustomerId(), false, (customer) => {
        this.RECORD_PARTY_SIGN = [
          ...this.RECORD_PARTY_SIGN,
          {
            enterpriseId: customer.customerId,
            order: this.valueAddPartyOrder,
            email: customer.customerEmail,
            enterpriseName: '',
            phone: customer.customerPhone,
            status: this.enumContractEnterpriseStatus.NO_PROCESS,
            isCreatedSide: false,
            customerId: this.documentService.getCustomerId(),
            name: customer.customerName,
            certificateNo: (customer.customerTaxCode.length > 0) ? customer.customerTaxCode : customer.customerCertificateNo,
            useDataForTemplate: false,
            isSignNoLogin: false,
            signConfig: { resize: false, showImage: false },
            customerType : customer.customerType
          }
        ];
        this.validateSetupParty();
        this.valueAddPartyOrder = Math.max.apply(Math, this.RECORD_PARTY_SIGN.map((o) => {
          return o.order;
        })) + 1;

        this.createContractService.isDirty = true;
        this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
      });
    });
  }

  changeChanKy(data){
if(data.signConfig.showImage){
  data.signConfig.showImage = true;
}
else data.signConfig.showImage = false;
  }

  changeCheckbox(data,check){
    if(check == 1){
      if(data.signConfig.showImage){
        data.signConfig.showImage = true;
        data.isSetupSignFlow = false;
      }
      else {
        data.signConfig.showImage = false;
        data.isSetupSignFlow = false;
      }
    }
    else  {
      if(data.isSetupSignFlow){
        data.signConfig.showImage = false;
        data.isSetupSignFlow = true;
      }
      else {
        data.isSetupSignFlow = false;
        data.signConfig.showImage = false;
      }
    }
  }

  public getCustomerById(id, isEdit = false, callback?: (customer) => void) {
    this.customerService.getCustomer(id).subscribe(rs => {
      if (rs != null && rs.data != null) {
        const customer: DocumentCustomerEntity = {
          customerAccountNumber: rs.data.accountNumber ? rs.data.accountNumber : '',
          customerAddress: rs.data.address ? rs.data.address : '',
          customerAdminUser: rs.data.adminUser ? rs.data.adminUser : '',
          customerAttachments: rs.data.attachments ? rs.data.attachments : '',
          customerBankBranch: rs.data.bankBranch ? rs.data.bankBranch : '',
          customerBankName: rs.data.bankName ? rs.data.bankName : '',
          customerBank: `${rs.data.bankName ? rs.data.bankName + ', ' : ''}${rs.data.bankBranch ? rs.data.bankBranch : ''}`,
          customerBirthday: rs.data.birthday ? this.commonService.formatDate(new Date(rs.data.birthday)) : null,
          customerCertificateId: rs.data.certificateId ? rs.data.certificateId : '',
          customerCertificateNo: rs.data.certificateNo && rs.data.customerType ? rs.data.certificateNo : '',
          customerCityId: rs.data.cityId ? rs.data.cityId : '',
          customerType: rs.data.customerType ? rs.data.customerType : '',
          customerDistrictId: rs.data.districtId ? rs.data.districtId : '',
          customerEmail: '',
          customerPhone: '',
          customerReceiverEmail: rs.data.email ? rs.data.email : '',
          customerEnterpriseId: rs.data.enterpriseId ? rs.data.enterpriseId : '',
          customerFax: rs.data.fax ? rs.data.fax : '',
          customerId: rs.data.customerId ? rs.data.customerId : '',
          customerIssuedAt: '',
          customerIssuedDate: '',
          customerIssuedDay: null,
          customerIssuedMonth: null,
          customerIssuedYear: null,
          customerName: rs.data.name ? rs.data.name : '',
          customerReceiverPhone: rs.data.phone ? rs.data.phone : '',
          customerPosition: rs.data.position ? rs.data.position : '',
          customerPrimaryEmail: rs.data.primaryEmail ? rs.data.primaryEmail : '',
          customerRepresentative: rs.data.representative
            ? this.commonService.capitalizeFirstLetter(rs.data.representative)
            : '',
          customerRepresentativeCertificateId: rs.data.representativeCertificateId ? rs.data.representativeCertificateId : '',
          customerRepresentativeCertificateNo: rs.data.representativeCertificateNo ? rs.data.representativeCertificateNo : '',
          customerRepresentativeIssuedAt: rs.data.representativeIssuedAt ? rs.data.representativeIssuedAt : '',
          customerRepresentativeIssuedDate: rs.data.representativeIssuedDate
            ? this.commonService.formatDate(new Date(rs.data.representativeIssuedDate))
            : null,
          customerSex: (typeof rs.data.sex !== 'undefined') ? (rs.data.sex ? 'Nam' : 'Nữ') : '',
          customerTaxCode: rs.data.taxCode ? rs.data.taxCode : '',
          customerWardId: rs.data.wardId ? rs.data.wardId : '',
          customerAddressUsing: rs.data.address ? rs.data.address : '',
          customerContacter: rs.data.name ? this.commonService.capitalizeFirstLetter(rs.data.name) : '',

          customerIndividualOrRepresentativeCertificate: rs.data.customerType === 10000
            ? rs.data.certificateNo
            : rs.data.representativeCertificateNo,
          customerIndividualOrRepresentativeIssuedAt: rs.data.customerType === 10000
            ? rs.data.issuedAt
            : rs.data.representativeIssuedAt,
          customerIndividualOrRepresentativeIssuedDate: rs.data.customerType === 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : this.commonService.formatDate(new Date(rs.data.representativeIssuedDate)),
          customerIndividualOrRepresentativeIssuedDay: null,
          customerIndividualOrRepresentativeIssuedMonth: null,
          customerIndividualOrRepresentativeIssuedYear: null,
          customerIndividualOrRepresentativeIssuedShortYear: null,
          customerBusinessCertificateNo: rs.data.customerType !== 10000 ? rs.data.certificateNo : '',
          customerBusinessCertificateIssuedAt: rs.data.customerType !== 10000 ? rs.data.issuedAt : '',
          customerBusinessCertificateIssuedDate: rs.data.customerType !== 10000
            ? this.commonService.formatDate(new Date(rs.data.issuedDate))
            : '',
          customerBusinessCertificateIssuedDay: '',
          customerBusinessCertificateIssuedMonth: '',
          customerBusinessCertificateIssuedYear: '',
          customerTaxCode_01: '',
          customerTaxCode_02: '',
          customerTaxCode_03: '',
          customerTaxCode_04: '',
          customerTaxCode_05: '',
          customerTaxCode_06: '',
          customerTaxCode_07: '',
          customerTaxCode_08: '',
          customerTaxCode_09: '',
          customerTaxCode_10: '',
          customerTaxCode_11: '',
          customerTaxCode_12: '',
          customerTaxCode_13: '',
          customerTaxCode_14: '',
          customerContacterApartmantNumber: '',
          customerContacterStreetName: '',
          customerContacterGroup: '',
          customerContacterWard: '',
          customerContacterDistrict: '',
          customerContacterCity: '',
          customerContacterPhone: '',
          customerContacterEmail: '',
        }

        // Since system allow user editing customer, the customerEmail and the customerPhone
        //  could be different from the origin email and phone of customer
        if (this.firstEditLoaded) {
          customer.customerEmail = this.document.email;
          customer.customerPhone = this.document.phone;
        } else {
          customer.customerEmail = rs.data.email ? rs.data.email : '';
          customer.customerPhone = rs.data.phone ? rs.data.phone : '';
        }

        // If customer is enterprise
        if (customer.customerType !== 10000) {
          customer.customerIssuedAt = rs.data.issuedAt ? rs.data.issuedAt : '';
          customer.customerIssuedDate = rs.data.issuedDate ? this.commonService.formatDate(new Date(rs.data.issuedDate)) : null;
          customer.customerIssuedDay = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getDate()
            : null;
          customer.customerIssuedMonth = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getMonth() + 1
            : null;
          customer.customerIssuedYear = rs.data.issuedDate
            ? new Date(rs.data.issuedDate).getFullYear().toString()
            : null;
        } else {
          customer.customerIssuedAt = '';
          customer.customerIssuedDate = '';
          customer.customerIssuedDay = null;
          customer.customerIssuedMonth = null;
          customer.customerIssuedYear = null;

        }
        // Generate splitted customerTaxCode
        for (let i = 0; i < 14; i++) {
          const key = `customerTaxCode_${i < 9 ? '0' + (i + 1) : i + 1}`;
          customer[key] = customer.customerTaxCode ? customer.customerTaxCode.charAt(i) : '';
        }

        if (customer.customerIndividualOrRepresentativeIssuedDate
          || customer.customerIndividualOrRepresentativeIssuedDate !== '') {
          const customerIndividualOrRepresentativeIssuedDate = customer.customerIndividualOrRepresentativeIssuedDate.split('/');
          customer.customerIndividualOrRepresentativeIssuedDay = customerIndividualOrRepresentativeIssuedDate[0];
          customer.customerIndividualOrRepresentativeIssuedMonth = customerIndividualOrRepresentativeIssuedDate[1];
          customer.customerIndividualOrRepresentativeIssuedYear = customerIndividualOrRepresentativeIssuedDate[2];
          customer.customerIndividualOrRepresentativeIssuedShortYear = customerIndividualOrRepresentativeIssuedDate[2].slice(-2);
        }


        if (customer.customerBusinessCertificateIssuedDate || customer.customerBusinessCertificateIssuedDate !== '') {
          const customerBusinessCertificateIssuedDate = customer.customerBusinessCertificateIssuedDate.split('/');
          customer.customerBusinessCertificateIssuedDay = customerBusinessCertificateIssuedDate[0];
          customer.customerBusinessCertificateIssuedMonth = customerBusinessCertificateIssuedDate[1];
          customer.customerBusinessCertificateIssuedYear = customerBusinessCertificateIssuedDate[2];
        } else {
          customer.customerBusinessCertificateIssuedDay = '';
          customer.customerBusinessCertificateIssuedMonth = '';
          customer.customerBusinessCertificateIssuedYear = '';
        }
        // In case of creating document by template, pass customer data to bind on template
        if ((this.document && this.document.typeId === 0) || this.valueSelect === 0) {
          this.onChangePanelData.next({
            customer: this.customer
          });
        }

        if (callback) {
          callback(customer);
        }
        if (this.isChangeParentDocument === true) {
          this.isChangeParentDocument = false;
          return;
        }
      }
    });
  }

  // validate form Enterprise.
  private validateSetupParty(event?: boolean) {
    let result = false;
    this.isInvalidSetPartyFlow = false;
    this.isInvalidSetCreatedSideParty = false;
    this.isInvalidSetPartyFlowWithBCT = false
    this.subscribeIsInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
    this.createContractService.isInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
    this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetPartyFlowWithBCT)
    this.subscribeIsNotAttestedInvalidSetCreatedSideParty.next(this.isInvalidSetCreatedSideParty);
    this.isEmailInvalid = false;
    this.isPhoneInvalid = false;
    const enterpriseId = localStorage.getItem('enterpriseId');
    const parentId = localStorage.getItem('parentId');
    if (this.RECORD_PARTY_SIGN.length === 0) {
      this.isInvalidSetPartyFlow = true;
      this.createContractService.isInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
      this.subscribeIsInvalidSetPartyFlow.next(this.isInvalidSetPartyFlow);
      result = true;
    } else {
      this.subscribeIsInvalidSetPartyFlow.next(false);
      if (this.cecaEnable && !this.isNotAttestedUser) {
        if (!event && this.RECORD_PARTY_SIGN.length === 1 && this.isConfirmBCT) {
          this.isInvalidSetPartyFlowWithBCT = true;
          this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetPartyFlowWithBCT);
          result = true;
        } else if (!event && !this.isConfirmBCT && (this.RECORD_PARTY_SIGN.length > 1
          || (this.RECORD_PARTY_SIGN[0].enterpriseId !== enterpriseId && this.RECORD_PARTY_SIGN[0].enterpriseId !== parentId))) {
          this.isInvalidSetPartyFlowWithBCT = true;
          this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetPartyFlowWithBCT);
          result = true;
        } else if(!this.checkExistedCreatorParty()) {
          this.isInvalidSetCreatedSideParty = true;
          this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetCreatedSideParty);
          result = true;
        }
      }
      //An
      // if (!this.isNotAttestedUser) {
      // //   // hợp đồng không chứng thực luôn phải có bên lập trong các bên tham gia kí kết
      //   if (!this.checkExistedCreatorParty()) {
      //     this.isInvalidSetCreatedSideParty = true;
      //     this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetCreatedSideParty);
      //     result = true;
      //   }
      //  }
      // if (this.isNotAttestedUser) {
      //   //   // hợp đồng không chứng thực luôn phải có bên lập trong các bên tham gia kí kết
      //   if (!this.checkExistedCreatorParty()) {
      //     this.isInvalidSetCreatedSideParty = true;
      //     this.subscribeIsInvalidSetPartyFlowWithConfirmBCT.next(this.isInvalidSetCreatedSideParty);
      //     result = true;
      //   }
      // }
    }

    this.RECORD_PARTY_SIGN.sort((a, b) => (a.order - b.order));
    this.RECORD_PARTY_SIGN.forEach((item, index) => {
      const regxPhone = new RegExp(this.phonePattern2);
      if (!regxPhone.test(item.phone)) {
        result = true;
        this.isPhoneInvalid = true;
      }
      if (item.email && item.email.length > 0) {
        const regxEmail = new RegExp(this.emailPattern);
        if (!regxEmail.test(item.email)) {
          result = true;
          this.isEmailInvalid = true;
        }
      } else {
        if (this.scopeType == 1) {
          const regxEmail = new RegExp(this.emailPattern);
          if (!regxEmail.test(item.email)) {
            result = true;
            this.isEmailInvalid = true;
          }
        }
      }
     
      // if (this.RECORD_PARTY_SIGN[index + 1]) {
      //   if (item.order + 1 < this.RECORD_PARTY_SIGN[index + 1].order) {
      //     // order không theo thứ tự
      //     this.isInvalidPartyOrder = true;
      //     result = true;
      //   }
      // }gi
    });
    return result;
  }

  matchesRegex(key, data) {
    let result = false
    if (key == 'phone') {
      const regxPhone = new RegExp(this.phonePattern2);
      if (!regxPhone.test(data)) {
        result = true;
      }
    }
    if (key == 'email') {
      if (data && data.length > 0) {
        const regxEmail = new RegExp(this.emailPattern);
        if (!regxEmail.test(data)) {
          result = true;
        }
      } else {
        if (this.scopeType == 1) {
          const regxEmail = new RegExp(this.emailPattern);
          if (!regxEmail.test(data)) {
            result = true;
          }
        }
      }
    }
    return result
  }

  // validate dữ liệu enterprise
  private validateErrorSetEnterprise() {
    // sắp xếp tăng dần theo order
    this.RECORD_PARTY_SIGN.sort((a, b) => (a.order - b.order));
    this.RECORD_PARTY_SIGN.forEach((item, index) => {
      if (this.RECORD_PARTY_SIGN[index + 1]) {
        if (item.order + 1 < this.RECORD_PARTY_SIGN[index + 1].order) {
          // order không theo thứ tự
        }
      }
    });
  }

  onChangeUserSignSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUserSign = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserValue.trim())
        .then(result => {
          if (this.inputUserValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUserSign = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

  onChangeUserSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchAutoDepartment(this.inputUserSignValue.trim())
        .then(result => {
          if (this.inputUserSignValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserOptions = [];
    }
  }


  autocompleteUserSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'approve')) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN
        // .map((item, index) => {
        //   return {
        //     ...item,
        //     role: this.roleUser.APPROVE + ''
        //   };
        // });

        const USER_SIGN = RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1')[0];
        if (USER_SIGN) {
          RECORD_USER_PERFORM_SIGN.splice(RECORD_USER_PERFORM_SIGN.indexOf(USER_SIGN), 1);
        }

        // if (!this.isBuyContract10Mb && this.isBuyContract1Mb && RECORD_USER_PERFORM_SIGN.length >= this.numberSizeApprove) {
        //   this.toastr.error(this.message.getMessage('messages.maximum_number_of_internal_approvers').replace('{0}', String(Math.floor(this.numberSizeApprove))));
        //   return;
        // }

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.length ? RECORD_USER_PERFORM_SIGN[RECORD_USER_PERFORM_SIGN.length - 1].order + 1 : 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.APPROVE + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ? this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.APPROVE + '' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        if (USER_SIGN) {
          USER_SIGN.order = RECORD_USER_PERFORM_SIGN.length + 1;
          RECORD_USER_PERFORM_SIGN.push(USER_SIGN);
        }
        this.createContractService.recordsUserPerformSign.next(RECORD_USER_PERFORM_SIGN);
        this.createContractService.isDirty = true;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        // this.isValidNoUserExist = false;
        // this.subscribeIsValidNoUserExist.next(false);
        // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
        // this.validateErrorSetUser();
        // console.log(this.RECORD_USER_PERFORM_SIGN);
      }
    }
  }

  autocompleteUserSignSelected($event: any, model: any) {
    this.setFormChanging(true);
    if ($event.isUserInput) {
      if ((!model.representativeId || !model.representativeIsActive) && model.type === 'DEPARTMENT') {
        if (!model.representativeId) {
          this.toastr.error(this.message.getMessage('messages.no_representative'));
        } else {
          this.toastr.error(this.message.getMessage('messages.representative_inactive'));
        }
        return;
      }

      const userId = model.type === 'USER' ? model.id : model.representativeId;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;

      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, 'sign')) {
        // Re-set all old members to "APPROVE" role
        let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN

        RECORD_USER_PERFORM_SIGN = [
          ...RECORD_USER_PERFORM_SIGN,
          {
            order: RECORD_USER_PERFORM_SIGN.length + 1,
            userId: model.type === 'USER' ? model.id : model.representativeId,
            enterpriseId: model.enterpriseId,
            enterpriseSignId: this.enterpriseIdInDocument,
            name: model.name,
            email: model.email,
            role: this.roleUser.SIGN + '',
            phone: model.phone,
            isCreatedSide: true,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            isSignDigitalCertificate: model.isSignDigitalCertificate ? model.isSignDigitalCertificate : false,
            signConfig: model.signConfig ?this.setDataSignConfig(JSON.parse(model.signConfig)) : { resize: false, showImage: model.isSignDigitalCertificate ? true : (this.roleUser.SIGN + '' == '1' ? true : false) },
            userPosition: model.userPosition
          }
        ];
        this.createContractService.recordsUserPerformSign.next(RECORD_USER_PERFORM_SIGN);
        this.createContractService.isDirty = true;
        this.inputUserValue = '';
        this.inputUserSignValue = '';
        this.isValidNoUserExist = false;
        this.subscribeIsValidNoUserExist.next(false);
        // this.valueSelectedUserRole = (this.roleUser.APPROVE + '');
        // this.validateErrorSetUser();
        // console.log(this.RECORD_USER_PERFORM_SIGN);
      }
    }
  }

  public onSubmit() {
    if(this.check != 2){
      if (!this.validateSetupParty() && !this.validateErrorSetUser()) {
        this.standardizedData();
        // console.log(this.RECORD_PARTY_SIGN);
        // console.log(this.RECORD_USER_PERFORM_SIGN);
        this.createContractService.recordsInternalUsers.next(this.RECORD_INTERNAL_USER);
        this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
        this.createContractService.recordsPartySign.next(this.RECORD_PARTY_SIGN);
        this.createContractService.isRecordsPartySignValid.next(true);
      } else {
        // this.toastr.error(this.message.getMessage('messages.error_establish_party_or_user'));
        if (!this.panels) {
          this.createContractService.isRecordsPartySignValid.next(false);
          this.blockUI.stop();
          return;
        }
        this.createContractService.isInvalidInfo.next(true);
        this.panels.forEach((x, index) => {
          if (index === 2 && (this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid || this.isInvalidSetCreatedSideParty)) {
            x.open();
          }
          if (index === 3 && this.isValidNoUserExist) {
            x.open();
          }
        });

        setTimeout(() => {
          if (this.isInvalidSetPartyFlow || this.isEmailInvalid && this.scopeType == 1 || this.isPhoneInvalid || this.isInvalidSetPartyFlowWithBCT || this.isInvalidSetCreatedSideParty) {
            document.getElementById('inputParty').focus();
          } else {
            document.getElementById('inputUserSign').focus();
          }
        }, 500);
        this.createContractService.isRecordsPartySignValid.next(false);
        this.blockUI.stop();
      }
    }
  }

  checkExistedUserOrDepartment(userName: string, departmentName: string, userId: string, departmentId?: string, email?: string, role?: string) {
    let userExist = 0;
    let departmentExist = 0;
    let roleType = false;

    const existedList = this.RECORD_USER_PERFORM_SIGN.filter((e) => {
      if (departmentId && e.departmentId === departmentId) {
        departmentExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      } else if (e.userId === userId) {
        userExist++;
        if (e.role === '1') {
          roleType = true;
        }
        return true;
      }
    });

    if (existedList.length > 0) {
      if (departmentExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_sign'), [departmentName]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_approve'), [departmentName]));
          }
        }
      } else if (userExist > 0) {
        if (role === 'sign') {
          this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
        } else {
          if (roleType) {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_sign'), [userName + ' - ' + email]));
          } else {
            this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_approve'), [userName + ' - ' + email]));
          }
        }
      }
      return true;
    } else {
      return false;
    }
  }

  onClickDeleteElementRecordInternalUser(id: any): void {

    this.RECORD_INTERNAL_USER = this.RECORD_INTERNAL_USER.filter(d => d.id !== id);
    if (this.RECORD_INTERNAL_USER.length > 0) {
      // update role of last user to SIGN
      this.createContractService.recordsInternalUsers.next(this.RECORD_INTERNAL_USER);
    } else {
      this.createContractService.recordsInternalUsers.next([]);
    }
    this.setFormChanging(true);
  }

  onClickDeleteElementRecordUser(userId: any, user: any): void {
    let RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.filter(d => d.userId !== userId);
    // RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN.map((item, index) => (
    //   {
    //     ...item,
    //     order: index + 1
    //   }));

    // update role of last user to SIGN
    // if (RECORD_USER_PERFORM_SIGN.length > 0) {
    //   RECORD_USER_PERFORM_SIGN[RECORD_USER_PERFORM_SIGN.length - 1].role = this.roleUser.SIGN + '';
    // }
    let userDelete = {
      ...user,
      isDelete: true
    }
    this.filterSignPositionApprove(userDelete);
    this.createContractService.recordsUserPerformSign.next(RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
    this.validateErrorSetUser();
  }

  changeCTS(user: any) {
    // this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
    this.filterSignPositionApprove(user);
  }

  filterSignPositionApprove(user: any) {
    const positions = this.createContractService.signPositions.getValue();
    const positionDataChange = positions.filter(position => !(position.enterpriseId === user.enterpriseId && position.userId === user.userId));
    this.createContractService.signPositions.next(positionDataChange);
    this.changePosition.emit(user);
  }

  changeDisplaySignature(user: any) {
    // this.createContractService.recordsUserPerformSign.next(this.RECORD_USER_PERFORM_SIGN);
    this.setFormChanging(true);
    this.filterSignPositionApprove(user);
  }

  // validate form User
  private validateErrorSetUser(model?) {
    // khi chủ thể không có chủ thể đang đăng nhập thì không kiểm tra user nữa
    const checkCurrentEnterprise = this.RECORD_PARTY_SIGN.filter(item => item.isCreatedSide === true);
    if (checkCurrentEnterprise.length === 0) {
      this.isValidNoUserExist = false;
      this.subscribeIsValidNoUserExist.next(false);
      return false;
    }

    // Kiểm tra trong list ko chua User nào?null
    const checkUserPerform = this.RECORD_USER_PERFORM_SIGN.filter(item => item.role === '1');
    if (checkUserPerform.length === 0) {
      this.isValidNoUserExist = true;
      this.subscribeIsValidNoUserExist.next(true);
      return true;
    } else {
      this.isValidNoUserExist = false;
      this.subscribeIsValidNoUserExist.next(false);
    }
    return false;
  }

  // update sign-enterprise Id for all users in current list
  private updateEnterpriseIdofUserList() {
    if (this.RECORD_USER_PERFORM_SIGN.length > 0) {
      const RECORD_USER_PERFORM_SIGN = this.RECORD_USER_PERFORM_SIGN.map((item) => {
        return {
          ...item,
          enterpriseSignId: this.enterpriseIdInDocument
        };
      });

      this.createContractService.recordsUserPerformSign.next(RECORD_USER_PERFORM_SIGN);
    }
  }

  onChangeUserRole(): void {
    this.validateErrorSetUser();
  }

  // -- End of Nghiep vu set User trong luong ky noi bo ---
  // ------------------------------------------------------

  private standardizedData() {
    // Reorder party list
    this.RECORD_PARTY_SIGN.sort((a, b) => (a.order - b.order));
    let nextOrder = 1;
    let currentOrder = this.RECORD_PARTY_SIGN[0].order;
    this.RECORD_PARTY_SIGN[0].order = 1;
    this.RECORD_PARTY_SIGN.forEach((item) => {
      if (item.order > currentOrder) {
        nextOrder += 1;
        currentOrder = item.order;
      }
      item.order = nextOrder;
    });

    // Nếu tạo hợp đồng upload thì ko sử dụng thông tin useDataForTemplate
    if (this.valueSelect !== 0) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map((item) => {
        return {
          ...item,
          useDataForTemplate: false
        };
      });
    }

    // Kiểm tra danh sách bên ký kết có bên Lập không
    // Nếu ko có >> xóa trắng danh sách người dùng ký kết
    const existedList = this.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true;
    });

    if (existedList.length <= 0) {
      this.createContractService.recordsUserPerformSign.next([]);
      this.createContractService.recordsInternalUsers.next([]);
      // this.RECORD_USER_PERFORM_SIGN = [];
    }
  }

  onChangeEnterpriseValue(key: string, data) {
    data[key] = data[key].trim() || '';
    const { enterpriseId, customerId } = data;
    if (this.scopeType == 1) {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map(item => {
        if (item.enterpriseId === enterpriseId) {
          return data;
        } else {
          return item;
        }
      });
    } else {
      this.RECORD_PARTY_SIGN = this.RECORD_PARTY_SIGN.map(item => {
        if (enterpriseId && item.enterpriseId === enterpriseId || customerId && item.customerId === customerId) {
          return data;
        } else {
          return item;
        }
      });
    }
   
  }

  openDialogProcedure(type: number, $event) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ProcedureComponent, {
      width: '70%',
      data: {
        type: type,
        internalFlowNotEdit: this.selectedServiceType ? this.selectedServiceType.internalFlowNotEdit : null
      }
    })

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.resetSignPosition.emit();
        // this.validateSetupParty(true);
      }
    });
  }

  openDialogAddCustomerApprove(data,i) {
    const dataPopup = this.dataPopupAddUserApprove;
    const dialogRef = this.dialog.open(  AddCustomerApproveDialogComponent
      , {
      width: '70%',
      data: {
        data:this.RECORD_PARTY_SIGN[i].customerApproves ? this.RECORD_PARTY_SIGN[i].customerApproves : [],
        customer:this.RECORD_PARTY_SIGN[i]
      }
    })

    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.RECORD_PARTY_SIGN[i].customerApproves = rs;
        // console.log(this.dataPopupAddUserApprove);
      }
      // else {
      //   this.dataPopupAddUserApprove = dataPopup;
      // }
    });
  }

  getServiceTypeByDocumentTypeId(idDocumentType: string) {
    // instance check=2 khong hien bang luong ky / khong dung typeDoc -> bo qua
    // de khong goi trung API voi instance check=1
    if (this.check == 2) {
      return;
    }
    // silent: khong block UI toan trang
    this.documentTypeService.getServiceTypeByDocumentTypeIdSilently(idDocumentType).subscribe(rs => {
      if (rs.data) {
        this.typeDoc = rs.data.type;
      }
    });
  }

  setColspan(maximumSpan: number): number {
    if (this.valueSelect !== 0) maximumSpan -= 1;
    if (this.isNotAttestedUser) maximumSpan -= 1;

    return maximumSpan;
  }

  setDataSignConfig(signConfig: any) {
    let newDataSignConfig = { ...signConfig };
    if(newDataSignConfig.resize === null || newDataSignConfig.resize === undefined) {
      newDataSignConfig = { ...newDataSignConfig, resize: false };
    }
    if(newDataSignConfig.showImage === null || newDataSignConfig.showImage === undefined) {
      newDataSignConfig = { ...newDataSignConfig, showImage: true };
    }
    return newDataSignConfig;
  }

  checkDisplayIconAddCustomer() {
    if(this.commonService.checkDefaultAdmin()) {
      return true;
    }
    if(this.permissions.includes(401) || this.permissions.includes(4)) {
      return true;
    }
    return false;
  }
}
